module.exports = "<div class=\"secure-user-account-confirmation\">\r\n    <div class=\"secure-user-account-confirmation__inner-wrapper well\">\r\n        <h1 class=\"h1 header--color-primary text-center margin-bottom-15\">Success!</h1>\r\n        <p class=\"text-center margin-bottom-25\">Your password has been changed. Nice one!</p>\r\n        <a class=\"btn btn-primary btn--has-icon secure-user-account-confirmation__button\" href=\"{{ url }}\">\r\n            {{ cta }} <span class=\"icon--right_arrow\"></span>\r\n        </a>\r\n    </div>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/secure-user-account/secure-user-account-confirmation-template.html
 ** module id = 999
 ** module chunks = 1
 **/